import DropdownController from "./dropdown_controller"

export default class extends DropdownController {
  setParamsForDateLockModal(event) {
    document.getElementById("date_lock_modal_company_ids").value = event.params.accountId
  }

  setParamsForCommentsModal(event) {
    document.getElementById("comments_modal_account_id").value = event.params.accountId
    document.getElementById("comments_modal_comments").value = event.params.comments
  }
}
